// FE→BE seam for navbar game search. Server counterpart:
// app/api/casino/games/suggestions/route.ts
// Imports from `domain/` are type-only.
import type { GameSuggestionsResponse } from "@/domain/casino/listing/types"

const SUGGESTIONS_ENDPOINT = "/api/casino/games/suggestions"

type SuggestionsRequestOptions = {
  signal?: AbortSignal
}

export async function fetchGameSuggestions(
  query: string,
  options: SuggestionsRequestOptions = {}
): Promise<GameSuggestionsResponse> {
  const params = new URLSearchParams({ q: query })
  const response = await fetch(`${SUGGESTIONS_ENDPOINT}?${params}`, {
    signal: options.signal
  })

  if (!response.ok) {
    throw new Error(`Game suggestions failed with status ${response.status}`)
  }

  return (await response.json()) as GameSuggestionsResponse
}
